export const MONOGRAM_MAIN =
  "M0,200 L92,0 L108,0 L108,62 L62,200 Z M228,200 L228,0 L282,0 L340,120 L398,0 L452,0 L452,200 L398,200 L398,96 L358,178 L322,178 L282,96 L282,200 Z M486,0 L604,0 L620,16 L620,86 L604,100 L620,114 L620,184 L604,200 L486,200 Z M530,40 L570,40 L580,50 L580,72 L570,82 L530,82 Z M530,118 L570,118 L580,128 L580,150 L570,160 L530,160 Z";

export const MONOGRAM_ACCENT = "M108,0 L124,0 L216,200 L154,200 L108,62 Z";

export const AMBLogo = ({ className = "", withWordmark = true, light = true }) => {
  const metal = light ? "url(#amb-metal-light)" : "url(#amb-metal-dark)";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="amb-logo">
      <svg viewBox="0 0 620 200" className="h-7 w-auto" role="img" aria-label="AMB Solutions">
        <defs>
          <linearGradient id="amb-metal-light" x1="0" y1="0" x2="0.8" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="36%" stopColor="#d7dee6" />
            <stop offset="54%" stopColor="#848e9a" />
            <stop offset="70%" stopColor="#f6f8fb" />
            <stop offset="100%" stopColor="#a9b2bd" />
          </linearGradient>
          <linearGradient id="amb-metal-dark" x1="0" y1="0" x2="0.8" y2="1">
            <stop offset="0%" stopColor="#3a4350" />
            <stop offset="50%" stopColor="#0b0f14" />
            <stop offset="100%" stopColor="#232b36" />
          </linearGradient>
          <linearGradient id="amb-blue" x1="0" y1="0" x2="0.45" y2="1">
            <stop offset="0%" stopColor="#9ad6ff" />
            <stop offset="38%" stopColor="#1e8bff" />
            <stop offset="100%" stopColor="#0043b2" />
          </linearGradient>
        </defs>
        <path fillRule="evenodd" fill={metal} d={MONOGRAM_MAIN} />
        <path fill="url(#amb-blue)" d={MONOGRAM_ACCENT} />
      </svg>
      {withWordmark && (
        <span className="hidden sm:block text-[10px] font-extralight tracking-[0.5em] text-slate-300 translate-y-px">
          SOLUTIONS
        </span>
      )}
    </span>
  );
};
